<template>
  <AppTooltip :disabled="!hasTooltip">
    <template #activator="{ props }">
      <div
        v-bind="props"
        ref="textContainer"
        class="text-truncate"
      >
        <span v-bind="$attrs">
          <slot />
        </span>
      </div>
    </template>
    <slot />
  </AppTooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'

export default defineComponent({
  name: 'TruncatedText',
  inheritAttrs: false,
  components: { AppTooltip },
  data () {
    return {
      hasTooltip: false,
    }
  },
  mounted () {
    (this.$refs['textContainer'] as HTMLDivElement)?.addEventListener(
      'mouseenter',
      (event) => {
        const textContainerDivElement = event.target as HTMLDivElement
        this.hasTooltip = textContainerDivElement.offsetWidth < textContainerDivElement.scrollWidth
      },
    )
  },
})
</script>
